export function AnimatedBackground() {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none" style={{ zIndex: -1 }}>
      {/* Base gradient layer */}
      <div
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(circle 500px at 20% 10%, #0d3d4a 0%, transparent 70%),
            radial-gradient(circle 400px at 80% 30%, #0f2d24 0%, transparent 65%),
            radial-gradient(circle 450px at 50% 100%, #0a1a2e 0%, transparent 70%),
            linear-gradient(180deg, #050508 0%, #0a0a0f 100%)
          `,
        }}
      />
      {/* Floating glow orbs — GPU-composited via translate3d(0,0,0) */}
      <div
        className="absolute rounded-full motion-safe:animate-[float1_12s_ease-in-out_infinite]"
        style={{
          width: '48vmax',
          height: '48vmax',
          top: '-25%',
          left: '-15%',
          background:
            'radial-gradient(circle, rgba(13, 120, 150, 0.6) 0%, rgba(13, 80, 100, 0.3) 40%, transparent 70%)',
          filter: 'blur(80px)',
          transform: 'translate3d(0,0,0)',
          willChange: 'transform, opacity',
        }}
      />
      <div
        className="absolute rounded-full motion-safe:animate-[float2_10s_ease-in-out_infinite]"
        style={{
          width: '48vmax',
          height: '48vmax',
          top: '10%',
          right: '-20%',
          background:
            'radial-gradient(circle, rgba(212, 165, 116, 0.5) 0%, rgba(212, 165, 116, 0.2) 40%, transparent 70%)',
          filter: 'blur(80px)',
          transform: 'translate3d(0,0,0)',
          willChange: 'transform, opacity',
        }}
      />
      <div
        className="absolute rounded-full motion-safe:animate-[float3_14s_ease-in-out_infinite]"
        style={{
          width: '45vmax',
          height: '45vmax',
          bottom: '-15%',
          left: '15%',
          background:
            'radial-gradient(circle, rgba(20, 180, 100, 0.4) 0%, rgba(15, 100, 60, 0.2) 40%, transparent 70%)',
          filter: 'blur(80px)',
          transform: 'translate3d(0,0,0)',
          willChange: 'transform, opacity',
        }}
      />
      {/* Noise texture overlay */}
      <div
        className="absolute inset-0"
        style={{
          opacity: 0.03,
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
        }}
      />
    </div>
  );
}
